import { globalStyles } from './global';

export const styles = {
  global: () => globalStyles,
};
